import generateStore from './generateStore.js'

export default (app) => generateStore('kmMaps', app)
